export const white = '#ffffff';
export const black = '#222222';
export const darkgrey = '#414141';
export const grey = '#a0a0a0';
export const lightgrey = '#c1c1c1';
export const brand = '#ec691a';
export const background = '#fcfcfc';
export const blueish = '#d9dde4';
export const acceptgreen = '#009900';
export const warningred = '#d0021b';
export const tabBackground = '#dfdfe1';
export const tableOddRowBg = '#f5f5f5';
export const filtersBackground = 'rgba(212, 212, 212, 0.5)';
export const filtersGrey = 'rgba(0, 0, 0, 0.54)';
export const tableOdd = '#F5F5F5';
export const buttonBackground = '#F5F5F5';
export const warmupBackground = '#EED202';
export const liveBackground = '#090';
